import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	loading: {
		id: 'skeletons.common.loading',
		defaultMessage: 'Loading',
		description: 'Alt text of skeleton image',
	},
});
